import { apiUc } from '../http';
import ServiceCRUD from './ServiceCRUDFLEXUC';

class CostCenterService extends ServiceCRUD {
  constructor() {
    super(`/api/centrosdecusto`);
  }

  /**
   * Busca todos os centro de custos.
   * @param {boolean} showDisabled - Se deve ou não mostrar desabilitados.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  findAll = (showDisabled = false) => {
    return apiUc.get(`${this.path}?showDisabled=${showDisabled}`);
  };

  /**
   * Busca um centro de custo.
   * @param {string} id - O ID do centro de custo.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  findById = (id) => {
    return apiUc.get(`${this.path}/${id}`);
  };

  /**
   * Busca todos os centros de custo que um atendente tem permissão.
   * @param {string} login - O ID do centro de custo.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  findAllowedByLogin = (login) => {
    return apiUc.get(`${this.path}/allowed/${login}`);
  };
}

export default new CostCenterService();
